/** @internalapi @module vanilla */ /** */
export * from './vanilla/index';
//# sourceMappingURL=vanilla.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/vanilla.js
// module id = 558
// module chunks = 1